import { forwardRef } from 'react';
import { Menu as MuiMenu, MenuProps as MuiMenuProps } from '@mui/material';

export type MenuProps = MuiMenuProps;

/**
 * Menu component - Anchored dropdown surface for `MenuItem` children.
 *
 * Thin wrapper around MUI Menu. Sits alongside `Popover` (Menu is built on
 * top of Popover in MUI) and gives the design system a hook for shared
 * paper styling, transitions, etc.
 *
 * @example
 * const [anchor, setAnchor] = useState<HTMLElement | null>(null);
 *
 * <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}>
 *   <MenuItem onClick={...}>Action</MenuItem>
 * </Menu>
 */
export const Menu = forwardRef<HTMLDivElement, MenuProps>((props, ref) => (
  <MuiMenu ref={ref} {...props} />
));

Menu.displayName = 'Menu';
